module.exports = __webpack_public_path__ + "static/img/icon-2.790786c2.png";